export const state = () => ({
  available: {
    Empresa: {
      jobTitle: 'Empresa',
      pdvMinDistance: 500,
      outRouteMultiplier: 0.2,
    },
    Gerente: {
      jobTitle: 'Gerente',
      pdvMinDistance: 500,
      outRouteMultiplier: 0.2,
    },
    Coordenador: {
      jobTitle: 'Coordenador',
      pdvMinDistance: 500,
      outRouteMultiplier: 0.2,
    },
    Generico: {
      jobTitle: 'Generico',
      pdvMinDistance: 500,
      outRouteMultiplier: 0.2,
    },
  },
})

export const mutations = {
  UPDATE_ROOT: (state, payload) =>
    payload.forEach(item => {
      state.available = { ...state.available, [item.jobTitle]: item }
    }),
}

export const actions = {
  async fetchAvailable({ commit, state, rootState }, force) {
    if (!navigator.onLine) return false
    const { parameters: offline } = rootState.offline
    if (offline.updating) return false
    if (offline.lastUpdate && !force) {
      const lastUpdate = new Date(offline.lastUpdate).getTime()
      const now = new Date().getTime()
      const diff = now - lastUpdate
      if (diff < 60000) return false
    }
    commit('offline/UPDATING', 'parameters', { root: true })
    try {
      const response = await this.$axios.get('/v3/app/sync/parameters')
      commit('UPDATE_ROOT', response.data)
      commit('offline/UPDATE', 'parameters', { root: true })
    } catch (e) {
      commit('offline/FAILED', 'parameters', { root: true })
      return false
    }
    return true
  },
}
